import styled from "@emotion/styled";
import { BackdropProps } from ".";
import theme from "../UI/theme";

export const ConfirmationContent = styled.div`
    padding: 30px 50px;
    text-align: center;
`;

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Header = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1.5rem 1rem 1rem;
    font-size: 1.25rem;
    line-height: 1.5;
    font-weight: ${theme.typography.fontWeight.thin};
    margin: 0;
`;

export const HorizontalLine = styled.hr`
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    margin: 0 1rem;
`;

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 1rem;
    gap: 1rem;

    & > div {
        &:first-of-type {
            font-size: 1.5rem;
        }
    }
`;

export const SelectContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 1.5rem;
`;

export const Select = styled.select`
    display: block;
    width: 60%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 12px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    & option {
        margin: 0.5rem 0;
    }

    &:focus {
        color: #495057;
        background-color: #fff;
        border-color: #80bdff;
        outline: 0;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
`;

export const ModalWrapper = styled.div`
    z-index: 1000;
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
`;

export const Backdrop = styled.div<BackdropProps>`
    @keyframes fadeIn {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 0.5;
        }
    }
    width: 100%;
    height: 100%;
    background-color: rgb(0, 0, 0);
    animation-duration: 0.3s;
    animation-name: fadeIn;
    animation-fill-mode: forwards;
    position: absolute;
    top: 0;
    left: 0;
`;

export const ModalClose = styled.div`
    position: absolute;
    top: 2rem;
    right: 2rem;
    cursor: pointer;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 0;
    color: rgba(0, 0, 0, 0.5);
    text-shadow: 0 1px 0 #fff;
`;

export const ModalBox = styled.div`
    @keyframes moveIn {
        0% {
            opacity: 0;
            top: 0;
        }
        100% {
            opacity: 1;
            top: 1.75rem;
        }
    }
    animation-duration: 0.5s;
    animation-name: moveIn;
    animation-fill-mode: forwards;
    display: inline-block;
    min-width: 300px;
    max-height: calc(100vh - 3rem);
    max-width: 90vw;
    position: relative;
    border-radius: 1rem;
    z-index: 1100;
    background-color: white;
    top: 1.75rem;
    left: 50%;
    transform: translateX(-50%);
`;

export const ModalFooter = styled.div`
    display: flex;
    justify-content: space-around;
    padding: 1.5rem 1rem;
`;
